export default "__VITE_ASSET__50c27a41__"